/* eslint-disable func-names */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Switch, useHistory } from "react-router-dom";
import * as moment from 'moment'
import AutoP2PPayment from "../components/AutoP2PPayment";
import { QRCodeCanvas } from "qrcode.react"
import { getAutoP2PPayments } from "../actions"
import { CONFIGS } from '../configs'
import { _formatCurrency } from '../utils'

import { CircleSpinnerOverlay, FerrisWheelSpinner } from 'react-spinner-overlay'

import {
  Badge,
  Button,
  Card,
  Form,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  InputGroup,
  Collapse,
  Modal,
  Table
} from "react-bootstrap";
import { basename } from "path";

class AutoP2P extends Component {
  constructor() {
    super();

    this.state = {
      autoP2PPayments: [],
      paymentOption: localStorage.getItem('autop2p_payment_option') ? localStorage.getItem('autop2p_payment_option') : CONFIGS.AUTOP2P_PAYMENT_OPTIONS.ORDER_ID
    }
  }

  componentDidMount() {
    this.props.getAutoP2PPayments();
  }

  componentWillReceiveProps(props) {
    if (props.autoP2PPayments.length > this.state.autoP2PPayments.length)
      this.setState({ autoP2PPayments: props.autoP2PPayments })
  }


  handleSelectPaymentOption = (e) => {
    localStorage.setItem('autop2p_payment_option', e.target.value);
    this.setState({ paymentOption: e.target.value });
  }

  renderPaymentOption = () => {
    var { paymentOption } = this.state;

    return (
      <div>
<div className="payment_option d-flex flex-column flex-md-row">
        <div className="mr-2"><b>Nội dung chuyển khoản:</b></div>
        <Form.Check
          type="radio"
          label="Order ID"
          value={CONFIGS.AUTOP2P_PAYMENT_OPTIONS.ORDER_ID}
          name="group1"
          onChange={this.handleSelectPaymentOption}
          checked={paymentOption === CONFIGS.AUTOP2P_PAYMENT_OPTIONS.ORDER_ID}
          className="me-4"
        />

        <Form.Check
          type="radio"
          label="Mẫu 1"
          value={CONFIGS.AUTOP2P_PAYMENT_OPTIONS.TEMPLATE_1}
          name="group1"
          onChange={this.handleSelectPaymentOption}
          checked={paymentOption === CONFIGS.AUTOP2P_PAYMENT_OPTIONS.TEMPLATE_1}
          className="me-4"
        />

        <Form.Check
          type="radio"
          label="Mẫu 2"
          value={CONFIGS.AUTOP2P_PAYMENT_OPTIONS.TEMPLATE_2}
          name="group1"
          onChange={this.handleSelectPaymentOption}
          checked={paymentOption === CONFIGS.AUTOP2P_PAYMENT_OPTIONS.TEMPLATE_2}
          className="me-4"
        />

        <Form.Check
          type="radio"
          label="Tùy chỉnh"
          value={CONFIGS.AUTOP2P_PAYMENT_OPTIONS.CUSTOM}
          name="group1"
          onChange={this.handleSelectPaymentOption}
          checked={paymentOption === CONFIGS.AUTOP2P_PAYMENT_OPTIONS.CUSTOM}
          className="me-4"
        />
      </div>
      </div>
      

    )
  }

  render() {
    console.log("autoP2PPayments", this.state.autoP2PPayments);

    return (
      <>
        <Container fluid id="autop2p-qr-page">
          <Row className="mb-4">
            <h2 className="text-center">AUTOP2P - QR</h2>
          </Row>

          <Row>
            <Col md="12" className="d-flex d-md-block justify-content-right align-items-right view-mode-option">
              {this.renderPaymentOption()}
            </Col>
          </Row>

          {this.state.autoP2PPayments.map(payment =>
            <AutoP2PPayment
              payment={payment}
              paymentOption={this.state.paymentOption}
            />
          )}
        </Container>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    autoP2PPayments: state.autoP2PReducer.autoP2PPayments
  }
}

export default connect(mapStateToProps, {
  getAutoP2PPayments
})(AutoP2P);